import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { DietDetails, Folder, FolderCategories } from './types.ts'

const getFolderCategories = async () => {
  try {
    const response = await httpClient.get<FolderCategories[]>(
      'api/folder_categories/'
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const postFolderCategories = async ({
  categoryName
}: {
  categoryName: string
}) => {
  try {
    const response = await httpClient.post<FolderCategories>(
      'api/folder_categories/',
      { name: categoryName }
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error('An unexpected error occurred:', error.response?.data)
    }
  }
}

const putFolderCategories = async ({
  categoryID,
  categoryName
}: {
  categoryID: number
  categoryName: string
}) => {
  try {
    const response = await httpClient.put<FolderCategories>(
      `api/folder_categories/${categoryID}/`,
      { name: categoryName }
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error('An unexpected error occurred:', error.response?.data)
    }
  }
}

const deleteFolderCategory = async ({ categoryID }: { categoryID: number }) => {
  try {
    const response = await httpClient.delete<FolderCategories>(
      `api/folder_categories/${categoryID}/`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error('An unexpected error occurred:', error.response?.data)
    }
  }
}

const getFolders = async (folderId: number, patientID: number) => {
  try {
    const response = await httpClient.get<Folder[]>(
      `api/folders/?category=${folderId}&patient_id=${patientID}`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const getUserFolders = async (folderId: number) => {
  try {
    const response = await httpClient.get<Folder[]>(
      `api/folders/?category=${folderId}`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const postFolder = async ({
  categoryID,
  kcal,
  meals,
}: {
  categoryID: number
  kcal: string
  meals: string
}) => {
  try {
    const response = await httpClient.post('api/folders/', {
      category: categoryID,
      kcal,
      number_of_meals: meals,
    })
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error('An unexpected error occurred:', error.response?.data)
    }
  }
}

const putFolder = async ({
  folderID,
  categoryID,
  kcal,
  meals
}: {
  folderID: number
  categoryID: number
  kcal: string
  meals: string
}) => {
  try {
    const response = await httpClient.put(`api/folders/${folderID}/`, {
      category: categoryID,
      kcal,
      number_of_meals: meals
    })
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error('An unexpected error occurred:', error.response?.data)
    }
  }
}

const deleteFolder = async ({ folderID }: { folderID: number }) => {
  try {
    const response = await httpClient.delete(`api/folders/${folderID}/`)
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error('An unexpected error occurred:', error.response?.data)
    }
  }
}

const getDietList = async (folderId: number) => {
  try {
    const response = await httpClient.get(`api/folders/${folderId}`)
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const getDietDetails = async (dietId: number) => {
  try {
    const response = await httpClient.get<DietDetails>(`api/diet_base/${dietId}`)
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const deleteDiet = async ({ dietId }: { dietId: number }) => {
  try {
    const response = await httpClient.delete(`api/diet_base/${dietId}/`)
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error('An unexpected error occurred:', error.response?.data)
    }
  }
}

export const dietBase = {
  getFolderCategories,
  postFolderCategories,
  putFolderCategories,
  deleteFolderCategory,
  getUserFolders,
  getFolders,
  postFolder,
  putFolder,
  deleteFolder,
  getDietList,
  getDietDetails,
  deleteDiet
}
